const baseUrl = "https://titan-container-service.vercel.app/api/v1";
// const baseUrl = "http://localhost:3456/api/v1";

export const AUTH_API = {
  LOGIN: `${baseUrl}/auth/login`,
  LOGOUT: `${baseUrl}/auth/logout`,
  REFRESH_TOKEN: `${baseUrl}/auth/refresh-token`,
  VALIDATE_TOKEN: `${baseUrl}/auth/validate-token`,
};
export const USERS_API = `${baseUrl}/email`;
export const EMAIL_API = `${baseUrl}/email`;
export const FETCH_ALL_CATEGORY_API = `${baseUrl}/newscategories`;
export const FETCH_ALL_ARTICLE_API = `${baseUrl}/articles`;
export const SIGN_IN_API = `${baseUrl}/user/sign-in`;
export const FETCH_ALL_EMAIL_API = `${baseUrl}/emails`;
